import { createSelector } from 'reselect';

/**
 * Direct selector to the homePage state domain
 */
const selectSignUpPageDomain = () => state => state.signUp;

/**
 * Other specific selectors
 */

const selectSignUpSuccessful = () => createSelector(
  selectSignUpPageDomain(),
  substate => substate.signUpSuccessful
)

const selectSignUpEmail = () => createSelector(
  selectSignUpPageDomain(),
  substate => substate.email
)
const selectVerificationResent = () => createSelector(
  selectSignUpPageDomain(),
  substate => substate.verificationResent
)
const selectVerificationResultPending = () =>
  createSelector(
    selectSignUpPageDomain(),
    (substate) => substate.verificationResultPending
  );
const selectEmailConfirmed = () => createSelector(
  selectSignUpPageDomain(),
  substate => substate.emailConfirmed
)

/**
 * Default selector used by SignUpPage
 */

const selectSignUpPage = () => createSelector(
  selectSignUpPageDomain(),
  (substate) => substate
);

export default selectSignUpPage;
export {
  selectSignUpPageDomain,
  selectSignUpSuccessful,
  selectSignUpEmail,
  selectVerificationResent,
  selectVerificationResultPending,
  selectEmailConfirmed
};



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/selectors.js